import { Component, OnInit } from '@angular/core';
import { GridColumnsConfiguration, GridFilter } from '../../shared/grid/grid.component';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { GridServiceService } from 'src/app/services/shared/grid-service.service';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/security/login.service';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { promise } from 'protractor';
import { log } from 'console';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'neoris-catalogue-devices',
  templateUrl: './catalogue-devices.component.html',
  styleUrl: './catalogue-devices.component.css'
})
export class CatalogueDevicesComponent implements OnInit  {

  arrayGirdDeviceManagementGrid: any[] = []
  arrayGirdDeviceManagement: any[] = []
  private onLanChange:Subscription
  languaje:string=''


  constructor(private controltowerservice:ControltowerService,
    private translate:TranslateService,
    private routers:Router,
    private propertiesService:PropertiesTowers,
    private ngxloader:NgxUiLoaderService
    
    
  ){

  }

  public gridColumnsConfiguration: GridColumnsConfiguration = {
    IconValue: "",
    IconColumnName: "",
    hiddenColumnNames: ["id", "typeId","clientId","deviceConfigurationUrl","brand","locationId", "ROW_ID"],
    dateColumns: [
      
    ],
    cardColum: "name",
    cardValues: [
      { place: 0, nombre: 'name', isMainColumn: false },
      { place: 0, nombre: 'code', isMainColumn: false },
      { place: 0, nombre: 'typeDevice', isMainColumn: false },
      { place: 0, nombre: 'ipAddress', isMainColumn: false },
      { place: 0, nombre: 'username', isMainColumn: false },
      { place: 0, nombre: 'password', isMainColumn: false },
      { place: 0, nombre: 'model', isMainColumn: false },
      { place: 0, nombre: 'serialNr', isMainColumn: false },
      { place: 0, nombre: 'location', isMainColumn: false }
    ],
    MultiIconColumns: [
      ],
    ActionColumn: {
      ColumnName: "",
      Actions: [
      ]
    }
  }

  async ngOnInit(): Promise<void> {
    this.ngxloader.start()
    let siteId = localStorage.getItem('site');
    let successDeviceManagement = null

    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.languaje = s.lang != undefined ? s.lang : "en";
       successDeviceManagement = this.getItemsCatalogeDevices(this.languaje, siteId)
    })

    if(this.languaje == undefined || this.languaje == ''){
     successDeviceManagement = this.getItemsCatalogeDevices('en', siteId)
    }
  }


  gotoSaveDevice(){
    this.propertiesService.setValueAddOrUpdateDevice(false)
    this.routers.navigate(["/savedevice"]);
    
  }

  public cellClick(obj: any) {
    this.propertiesService.setValueAddOrUpdateDevice(true)
    localStorage.setItem('rowSelectCatDevice',JSON.stringify(obj))
    console.log("rowSelectCatDevice", obj)  
    this.routers.navigate(['/savedevice'])
  }

  

  private async getItemsCatalogeDevices(lang:string,siteId:string): Promise<boolean> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getCatalogeSourcesDevices(lang,siteId).subscribe(
        {
          next: (arraydevices: any={}) => {

            arraydevices = arraydevices.map((device, index) => ({
              ...device,
              ROW_ID: index + 1,
            }));

            //this.fillDataDeviceManagement(arraydevices)
            this.arrayGirdDeviceManagementGrid = arraydevices
       
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  
 


}
